export default {"src":"/_next/static/media/double_quotes.1f1fd238.svg","height":196,"width":196,"blurWidth":0,"blurHeight":0};